<template>
  <div
    class="news"
    id="noticias"
    :style="`background-image: url(${require('@/assets/news-background.jpg')})`"
    v-if="news.length"
  >
    <b-container>
      <b-row align-h="center">
        <b-col sm="8" class="text-center">
          <h1 class="font-weight-bold mb-3">
            Noticias
          </h1>
          <p class="font-weight-light">
            Relacionadas a nuestro estudio y trabajo.
          </p>
        </b-col>
        <b-col sm="12" class="px-0 px-sm-3">
          <NewsCarousel class="mt-4" :news="news" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NewsCarousel from "@/components/NewsCarousel";
import { db } from "../services/firebase";

export default {
  name: "News",
  components: {
    NewsCarousel
  },
  data() {
    return {
      news: []
    };
  },
  async created() {
    await db
      .collection("news")
      .get()
      .then((docs) => {
        let newsColl = [];

        docs.forEach(function (doc) {
          let newDoc = doc.data();
          newDoc.id = doc.id;
          newsColl.push(newDoc);
        });

        this.news = newsColl;

        // new chunk every 3 elements
        // this.news = newsColl.reduce((resultArray, item, index) => {
        //   const chunkIndex = Math.floor(index / 3);

        //   if (!resultArray[chunkIndex]) {
        //     resultArray[chunkIndex] = []; // start a new chunk
        //   }

        //   resultArray[chunkIndex].push(item);

        //   return resultArray;
        // }, []);
      });
  }
};
</script>

<style scoped lang="sass">
.news
  margin: 8rem 0
  background-position: left center
  background-repeat: no-repeat
  background-size: contain
  @media screen and (max-width: 502px)
    margin: 8rem 0 6rem 0
</style>
